import React from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import NavBar from './Components/NavBar/NavBar';
import Home from './Pages/Home';
import AddJob from './Pages/AddJob';
import UpdateJob from './Pages/UpdateJob';
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home></Home>}></Route>
          <Route path='/add-job' element={<AddJob></AddJob>}></Route>
          <Route path='/update/:id' element={<UpdateJob></UpdateJob>}></Route>

        </Routes>

      </BrowserRouter>

    </div>
  );
}

export default App;
